import React from 'react';

interface DroneSoccerLandingProps {
  windowWidth: number;
}

export const DroneSoccerLanding: React.FC<DroneSoccerLandingProps> = ({
  windowWidth,
}) => {
  return (
    <section className="soccer-landing-section">
      <div className="soccer-landing-titles-container">
        <h1 className="soccer-landing-subtitle">Stem meets Sport</h1>
        <h2 className="soccer-landing-title">
          {windowWidth > 991 ? (
            <>
              <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                DRONE SOCCER
              </span>
            </>
          ) : (
            <>
              <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                DRONE
              </span>
              <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                SOCCER
              </span>
            </>
          )}
        </h2>
      </div>
      <div className="soccer-landing-description-container">
        <p className="soccer-landing-description">
          Drone Soccer is a team-based indoor sport where students fly, build,
          and repair drones made for action and collisions, while also gaining
          hands-on skills that stick!
        </p>
        <div className="dreamX__discover--button">
          <a
            href="/drone-soccer-contact"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            get in touch
          </a>
        </div>
      </div>
    </section>
  );
};
